<ng-container *ngIf="customerData">
  <div class="row">
    <div class="col-12 col-lg-6">
      <div class="card border-0 shadow">
        <div class="card-body">
          <h5 class="card-title">{{'CUSTOMER-ACCOUNT.DETAILS-VIEW.USER-INFORMATION.TITLE' | translate}}</h5>
          <div class="d-flex flex-column">
            <div class="d-flex flex-column flex-sm-row mb-2 no-gutters">
              <div class="col-5 col-sm-4 fw-bold ">{{'CUSTOMER-ACCOUNT.DETAILS-VIEW.USER-INFORMATION.NAME' | translate}}</div>
              <div class="text-secondary notranslate">
                <span>{{ customerData.firstName }}&nbsp;</span>
                <span *ngIf="customerData.nameInfix">{{ customerData.nameInfix }}&nbsp;</span>
                <span>{{ customerData.lastName }}</span>
              </div>
            </div>
            <div class="d-flex flex-column flex-sm-row mb-2 no-gutters">
              <div class="col-5 col-sm-4 fw-bold">{{'CUSTOMER-ACCOUNT.DETAILS-VIEW.USER-INFORMATION.EMAIL' | translate}}</div>
              <div class="text-secondary">{{customerData.email}}</div>
            </div>
            <div class="d-flex flex-column flex-sm-row mb-2 no-gutters">
              <div class="col-5 col-sm-4 fw-bold">{{'CUSTOMER-ACCOUNT.DETAILS-VIEW.USER-INFORMATION.TELEPHONE' | translate}}</div>
              <div class="text-secondary">{{customerData.country.phoneCode + customerData.mobileNumber}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
